import bgBG from '../translations/bg_BG.json';
import csCZ from '../translations/cs_CZ.json';
import deAT from '../translations/de_AT.json';
import deCH from '../translations/de_CH.json';
import deDE from '../translations/de_DE.json';
import deLU from '../translations/de_LU.json';
import elEL from '../translations/el_EL.json';
import enGB from '../translations/en_GB.json';
import esES from '../translations/es_ES.json';
import etEE from '../translations/et_EE.json';
import frBE from '../translations/fr_BE.json';
import frCH from '../translations/fr_CH.json';
import frFR from '../translations/fr_FR.json';
import frLU from '../translations/fr_LU.json';
import hrHR from '../translations/hr_HR.json';
import huHU from '../translations/hu_HU.json';
import itIT from '../translations/it_IT.json';
import ltLT from '../translations/lt_LT.json';
import lvLV from '../translations/lv_LV.json';
import nlBE from '../translations/nl_BE.json';
import nlNL from '../translations/nl_NL.json';
import plPL from '../translations/pl_PL.json';
import ptPT from '../translations/pt_PT.json';
import roRO from '../translations/ro_RO.json';
import ruRU from '../translations/ru_RU.json';
import skSK from '../translations/sk_SK.json';
import slSI from '../translations/sl_SI.json';
import trTR from '../translations/tr_TR.json';
import ukUA from '../translations/uk_UA.json';

export default function Translator() {
  this.init = function (locale) {
    const localesMapping = {
      'bg-bg': bgBG,
      'cs-cz': csCZ,
      'de-at': deAT,
      'de-ch': deCH,
      'de-de': deDE,
      'de-lu': deLU,
      'el-el': elEL,
      'en-gb': enGB,
      'es-es': esES,
      'et-ee': etEE,
      'fr-be': frBE,
      'fr-ch': frCH,
      'fr-fr': frFR,
      'fr-lu': frLU,
      'hr-hr': hrHR,
      'hu-hu': huHU,
      'it-it': itIT,
      'lt-lt': ltLT,
      'lv-lv': lvLV,
      'nl-be': nlBE,
      'nl-nl': nlNL,
      'pl-pl': plPL,
      'pt-pt': ptPT,
      'ro-ro': roRO,
      'ru-ru': ruRU,
      'sk-sk': skSK,
      'sl-si': slSI,
      // 'sr-latn-rs': srLatnRs,
      'tr-tr': trTR,
      'uk-ua': ukUA
    }
    this.translations = localesMapping[locale.toLowerCase()] || enGB;
  }

  this.translate = function (key) {
    const keys = key.split('.');

    let value = this.translations;
    for (let i = 0; i < keys.length; i++) {
      if (value) {
        value = value[keys[i]];
      } else {
        break;
      }
    }
    return value || '';
  }
}
